import type { RefObject } from 'react'

import { useEffect, useRef } from 'react'
import { track } from '@/lib/motion/engine'

interface ScrollProgressOptions {
    startAt?: number
    endAt?: number
    varName?: string | null
    onUpdate?: (progress: number) => void
    enabled?: boolean
}

export const useScrollProgress = <T extends HTMLElement>(
    ref: RefObject<T | null>,
    options: ScrollProgressOptions = {}
): void => {
    const { startAt = 1, endAt = 0, varName = '--p', enabled = true } = options
    const callback = useRef(options.onUpdate)

    callback.current = options.onUpdate

    useEffect(() => {
        const el = ref.current

        if (!el || !enabled) return

        return track(el, {
            startAt,
            endAt,
            varName,
            onUpdate: progress => callback.current?.(progress)
        })
    }, [ref, startAt, endAt, varName, enabled])
}
